import React, { useState, useEffect, useRef } from 'react'
import { Outlet } from 'react-router-dom'
import { HiOutlineMenuAlt2 } from 'react-icons/hi'
import Sidebar from './Sidebar'
import SessionTimeout from '../SessionTimeout'
import { useSessionPresentation } from '../../lib/SessionPresentationContext'
import '../../styles/print.css'

export default function Layout({ onLogout }) {
    const sessionPresentation = useSessionPresentation()
    const menuButton = useRef(null)

	const [isPrintMode, setIsPrintMode] = useState(false)

	const [sidebarOpen, setSidebarOpen] = useState(() => {
		const saved = localStorage.getItem('sidebarOpen')
		return saved !== null ? JSON.parse(saved) : window.innerWidth >= 1024
	})

	useEffect(() => {
		localStorage.setItem('sidebarOpen', JSON.stringify(sidebarOpen))
	}, [sidebarOpen])

	useEffect(() => {
		const handleResize = () => {
			if (window.innerWidth < 1024) {
				setSidebarOpen(false)
			} else {
				const saved = localStorage.getItem('sidebarOpen')
				setSidebarOpen(saved !== null ? JSON.parse(saved) : true)
			}
		}

		handleResize()
		window.addEventListener('resize', handleResize)

		return () => window.removeEventListener('resize', handleResize)
	}, [])

	useEffect(() => {
		const beforePrint = () => setIsPrintMode(true)
		const afterPrint = () => setIsPrintMode(false)

		window.addEventListener('beforeprint', beforePrint)
		window.addEventListener('afterprint', afterPrint)

		return () => {
			window.removeEventListener('beforeprint', beforePrint)
			window.removeEventListener('afterprint', afterPrint)
		}
	}, [])

	return (
	<div className="app-layout bg-slate-50 h-full min-h-0 w-full overflow-hidden flex flex-row">
		<div className="app-sidebar">
		<Sidebar
			onLogout={onLogout}
			sidebarOpen={sidebarOpen}
		/>
		</div>

		<div className="app-main flex min-h-0 min-w-0 flex-1 flex-col">
		<div className="app-header relative z-30 h-14 shrink-0 min-w-0 bg-white border-b px-3 py-2 flex items-center gap-2">
			<button
				ref={menuButton}
			onClick={() => setSidebarOpen(!sidebarOpen)}
			className="shrink-0 p-2 rounded hover:bg-gray-100 transition"
			title={sidebarOpen ? 'Hide menu' : 'Show menu'}
			>
			<HiOutlineMenuAlt2 className="text-xl text-gray-700" />
			</button>
            {sessionPresentation && <SessionTimeout {...sessionPresentation} returnFocusRef={menuButton} />}
		</div>

		<div className="app-content min-h-0 flex-1 overflow-x-hidden overflow-y-auto p-4">
			<Outlet />
		</div>
		</div>
	</div>
	)
}
